import { Router } from '@angular/router';
import { BuildsService } from './../Services/builds/builds.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-builds',
  templateUrl: './builds.component.html',
  styleUrls: ['./builds.component.css']
})
export class BuildsComponent implements OnInit {
  builds: any;
  // *****************************
  newBuildId: string;
  newPackageName: string;
  newCompileSdkVersion: string;
  newMinSdkVer: string;
  newTargetSdkVer: string;
  newVerCode: string;
  newVerName: string;
  newDownloadLink: string;
  // *******************************
  editEnable: boolean;
  // EPackageName: string;
  // ECompileSdkVersion: string;
  // EMinSdkVer: string;
  // ETargetSdkVer: string;
  // EVerCode: string;
  // EVerName: string;
  // EDownloadLink: string;
  // ********************************
  newBuild: any;
  Ebuild: any;
  build: any;
  file: File;
  constructor(private buildsService: BuildsService, private router: Router) { }


  ngOnInit() {
    this.getAllBuilds();
    
  }
  ngOnchange() {
    this.getAllBuilds();
  }



  editBuild(build: string) {
      this.editEnable = true;
      console.log(build);
      this.Ebuild = build;

    }
    saveEditing(id,build) {
      console.log('build', build);
      const form = new FormData();
      form.append('buildId', this.Ebuild.buildId);
      form.append('packageName', this.Ebuild.packageName);
      form.append('compileSdkVersion', this.Ebuild.compileSdkVersion);
      form.append('minSdkVersion', this.Ebuild.minSdkVersion);
      form.append('targetSdkVersion', this.Ebuild.targetSdkVersion);
      form.append('versionCode', this.Ebuild.versionCode);
      form.append('versionName', this.Ebuild.versionName);
      form.append('downloadLink', this.file);
      this.buildsService.editBuild(id, form).subscribe(
        next => {
          console.log('next', next);
           this.editEnable = false;
           this.Ebuild = '';
           this.getAllBuilds();
    }, error => {
      console.log(error);
    });
    }

    addBuild() {
      const form = new FormData();
      form.append('buildId', this.newBuildId);
      form.append('packageName', this.newPackageName);
      form.append('compileSdkVersion', this.newCompileSdkVersion);
      form.append('minSdkVersion', this.newMinSdkVer);
      form.append('targetSdkVersion', this.newTargetSdkVer);
      form.append('versionCode', this.newVerCode);
      form.append('versionName', this.newVerName);
      form.append('downloadLink', this.file);
      this.buildsService.addBuild(form).subscribe(
        next => {
        console.log(next);
        this.getAllBuilds();
        this.newBuild = !this.newBuild;
        console.log('newBuild',this.newBuild);
        this.newPackageName = '';
        this.newCompileSdkVersion = '';
        this.newMinSdkVer = '';
        this.newTargetSdkVer = '';
        this.newVerCode = '';
        this.newVerName = '';
        this.newDownloadLink = '';
      }, error => {console.log(error); });
    }


  /**
   * get all
   *@description get all cats from backend 
   */

  getAllBuilds() {
    this.buildsService.getBuilds().subscribe(
      next => {
      this.builds = next;
      console.log(this.builds);
    }, error => {console.log(error); });
  }
  getpkgBuilds(pkgId) {
    this.buildsService.getpkgBuilds(pkgId).subscribe(
      next => {

      }
    );
  }
  deleteBuild(id,index) {
    console.log(this.builds);
    console.log(index);
    this.buildsService.deleteBuild(id).subscribe(
      next => {
        this.builds.splice(index, 1);
      }
    );
  }
  getFile(inputfile){

    if(inputfile.target.files&&inputfile.target.files[0]){
      this.file=inputfile.target.files[0];
      console.log('file',this.file);
    }
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/builds/builds.component.ts